export const CCIS_IMAGE = {
  baseURl: 'https://kong-proxy-aws.toyota-europe.com',
  token: '069ba2cc-15ae-4865-9911-7c3934841b2c', 
  vehicle: '70b24596-9d70-446c-b719-0449792a362e',
  width: 500,
  height: 500,
  angle: 9, 
  quality: 70, 
  type: 'day-exterior',
  color: '212',
  upholstery: '',
  countryCode: 'gb'
};

export const FALLBACK_THUMBNAIL_IMAGE = 'lexus.jpeg';